import PrivacyPolicy from "../../../pages-v1/PrivacyPolicy";

export const Page = PrivacyPolicy;
